// color variables

const colors = {

  // text
  primaryText:   'hsl(220, 20%, 30%)',
  secondaryText: 'hsl(220, 20%, 50%)',
  tertiaryText:  'hsl(220, 20%, 70%)',

  // neutrals
  black:      'hsl(220, 20%,  20%)',
  white:      'hsl(220, 100%, 100%)',
  
  // roy g biv
  red:         'hsl(0,    80%, 70%)',
  orange:      'hsl(35,  100%, 50%)',
  green:       'hsl(125,  60%, 40%)',
  blue:        'hsl(220,  80%, 60%)',
  
  // light
  lightGray:   'hsl(220, 20%, 95%)',
  lightRed:    'hsl(0,   80%, 95%)',
  lightOrange: 'hsl(35, 100%, 95%)',
  lightYellow: 'hsl(55, 100%, 95%)',
  lightGreen:  'hsl(125, 60%, 95%)',
  lightBlue:   'hsl(220, 80%, 95%)',
  
  // translucent
  smoke:       'hsla(220, 20%, 90%, .7)',

  toastBg: 'hsla(220, 20%, 90%, .2)',
}

export default colors



// WEBPACK FOOTER //
// ./src/styles/colors.js